import { TPromotionsResponseIType } from 'api/signUp/transformers/promotionsResponse';

export const makeDefaultSelectedPromoCode = (
  data: TPromotionsResponseIType | undefined,
  queryParams: URLSearchParams,
): string => {
  if (data) {
    if (data.length === 1) {
      return data[0].bonusCode;
    }

    const promoCodeFromParams = queryParams.get('promoCode');
    if (
      promoCodeFromParams &&
      data.some((bonus) => bonus.bonusCode === promoCodeFromParams)
    ) {
      return promoCodeFromParams;
    }
  }

  return '';
};
